/* eslint-disable */

export function copy(obj){
    if(obj == null || typeof(obj) != 'object')
        return obj;

    var temp = new obj.constructor();
    for(var key in obj)
        temp[key] = copy(obj[key]);

    return temp;
}

export default copy;
